import { render, staticRenderFns } from "./CustomersItem.vue?vue&type=template&id=fde2fd1a&"
import script from "./CustomersItem.vue?vue&type=script&lang=ts&"
export * from "./CustomersItem.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersItem.vue?vue&type=style&index=0&id=fde2fd1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports